import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, FormControlLabel } from "@mui/material";
import { Box, Typography } from "@mui/material";

import { Formik } from "formik";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";

const MastodonSettingsPopupForm = (props) => {
  const { open, close, task, updateTaskParams } = props;
  const {
    instance,
    hashtag,
    focused,
    threshold,
    monitoring,
    monitoring_interval,
    post_limit,
  } = task;

  return (
    <Formik
      initialValues={{
        instance,
        hashtag,
        focused,
        threshold,
        monitoring,
        monitoring_interval,
        post_limit,
      }}
      onSubmit={(values) => updateTaskParams({ ...values })}
    >
      {({ handleChange, handleSubmit, resetForm, values }) => (
        <Dialog open={open}>
          <DialogTitle>
            <Typography>
              #{hashtag} @ {instance}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", minWidth: 300, minHeight: 300 }}>
              <Box sx={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-evenly" }}>
                <FormControlLabel
                  control={
                    <Switch
                      onChange={handleChange("monitoring")}
                      value={values.monitoring}
                      checked={values.monitoring}
                    />
                  }
                  label="Monitoring"
                />
                <FormControlLabel
                  control={
                    <Switch
                      onChange={handleChange("focused")}
                      value={values.focused}
                      checked={values.focused}
                    />
                  }
                  label="Focused"
                />
                <Box sx={{ height: 40 }} />
              </Box>
              <Box sx={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-evenly", alignItems: "flex-end" }}>
                <TextField
                  sx={{ maxWidth: 100, minWidth: 100 }}
                  onChange={handleChange("monitoring_interval")}
                  value={values.monitoring_interval}
                  variant="outlined"
                  type="number"
                  label="Interval (days)"
                  size="small"
                  InputProps={{ inputProps: { min: 0 } }}
                />
                <TextField
                  sx={{ maxWidth: 100, minWidth: 100 }}
                  onChange={handleChange("threshold")}
                  value={values.threshold}
                  variant="outlined"
                  type="number"
                  label="Threshold"
                  size="small"
                  InputProps={{ inputProps: { min: 0, max: 1, step: 0.1 } }}
                />
                <TextField
                  sx={{ maxWidth: 100, minWidth: 100 }}
                  onChange={handleChange("post_limit")}
                  value={values.post_limit}
                  variant="outlined"
                  type="number"
                  label="Post limit"
                  size="small"
                  InputProps={{ inputProps: { min: 0, step: 1 } }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={() => { handleSubmit(); close(); }}>
              OK
            </Button>
            <Button variant="outlined" onClick={() => { resetForm(); close(); }}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Formik>
  );
};

export default MastodonSettingsPopupForm;
